import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FaGlobe, FaChevronUp } from 'react-icons/fa';

const LanguageSelector = ({ language, setLanguage }) => {
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: 'English', flag: '🇮🇳' },
    { code: 'hi', name: 'हिंदी', flag: '🇮🇳' },
    { code: 'or', name: 'ଓଡ଼ିଆ', flag: '🇮🇳' }
  ];

  const currentLanguage = languages.find(lang => lang.code === language);

  return (
    <div className="language-selector-fixed">
      <Dropdown 
        show={isOpen}
        onToggle={(nextShow) => setIsOpen(nextShow)}
        drop="up"
        align="start"
      >
        <Dropdown.Toggle 
          as="div"
          className="language-toggle"
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="language-toggle-content">
            <FaGlobe className="globe-icon" />
            <span className="language-text">{currentLanguage.flag} {currentLanguage.name}</span>
            <FaChevronUp className={`chevron-icon ${isOpen ? 'rotated' : ''}`} />
          </div>
        </Dropdown.Toggle>
        
        <Dropdown.Menu className="language-dropdown-fixed">
          {languages.map(lang => (
            <Dropdown.Item 
              key={lang.code}
              onClick={() => {
                setLanguage(lang.code);
                setIsOpen(false);
              }}
              className={`language-option ${language === lang.code ? 'active' : ''}`}
            >
              <span className="flag">{lang.flag}</span>
              <span className="name">{lang.name}</span>
              {language === lang.code && <span className="check">✓</span>}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LanguageSelector;